import * as React from "react";
import _ from "lodash";
const d3 = require("d3-format");
import { Table } from "antd";
import { StoreVisits } from "./container";
import { StoreVisits as StoreVisitsConstants } from "../../constants";
import { StoreNameCell } from "./StoreNameCell";
import "./style.scss";

class TopStoresTable extends React.Component<
  StoreVisits.TopStoreVisitsActions & StoreVisits.TopStoreVisitsProps,
  {}
> {
  formatCount(value: number) {
    const setup = ",";
    const formatter = d3.format(setup);
    return formatter(value);
  }

  componentWillReceiveProps(
    nextProps: StoreVisits.TopStoreVisitsProps,
    nextState: any
  ) {
    let { publicationIds, startDate, endDate } = this.props;
    let forceFetch =
      nextProps.publicationIds != publicationIds ||
      nextProps.startDate != startDate ||
      nextProps.endDate != endDate;

    if (
      forceFetch &&
      nextProps.publicationIds &&
      nextProps.startDate &&
      nextProps.endDate
    ) {
      this.props.getTopStoresData(
        nextProps.publicationIds,
        nextProps.startDate,
        nextProps.endDate
      );
    }
  }

  mapDataToRows() {
    let { topStoresData } = this.props;

    return topStoresData.map(
      (item: StoreVisitsConstants.TopStoreData, index: number) => {
        return {
          key: index,
          rank: index + 1, // Start rank at #1
          name: <StoreNameCell name={item.name} address={item.address} />,
          scaled_visits: this.formatCount(item.scaled_visits)
        };
      }
    );
  }

  render() {
    const { topStoresData } = this.props;
    return (
      topStoresData.length > 0 && (
        <div className="top-stores-table">
          <span className="table-title">Top Stores by Trips</span>
          <Table
            pagination={{ total: topStoresData.length, pageSize: 10 }}
            size="middle"
            dataSource={this.mapDataToRows()}
            columns={TOP_STORE_COLUMNS}
          />
        </div>
      )
    );
  }
}

const TOP_STORE_COLUMNS = [
  {
    className: "rank",
    dataIndex: "rank",
    key: "rank",
    width: 30,
    sorter: (a: any, b: any) => a.rank - b.rank
  },
  {
    className: "store-names",
    title: "STORE NAMES",
    dataIndex: "name",
    key: "name",
    width: 150,
    sorter: (a: any, b: any) =>
      a.name.props.name.localeCompare(b.name.props.name)
  },
  {
    className: "store-trips",
    title: "STORE TRIPS",
    dataIndex: "scaled_visits",
    key: "scaled_visits",
    width: 100,
    sorter: (a: any, b: any) => a.scaled_visits - b.scaled_visits
  }
];

export default TopStoresTable as any;



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/TopStoresTable/component.tsx